import { OUTPUTS_ENUM_CHANGED, OUTPUTS_LOGOUT } from "../../const/actionsType";

export function acOutputsEnumChanged(pData) {
  return {
    type: OUTPUTS_ENUM_CHANGED,
    payload: pData,
  };
}

export function acOutputsLogout() {
  return {
    type: OUTPUTS_LOGOUT,
  };
}
